import {
  VERBAL_ORDERS_MENU,
  IDG_MENU,
  EA_MENU,
  CascadeMenuItem,
  GeneralOrder,
  LOCchange,
  MedicationChange,
  CPVisitFrequencies,
  FACchange,
  AdmitOrder,
  DischargeOrder,
  PSOorder,
  PRNOrder,
} from '@mummssoftware/utils/orders';

// Get enabled order types so that we can filter them out
const displayNoteOrderTypes: Record<string, unknown> = window.env
  ?.displayNoteOrderTypes as Record<string, unknown>;
const VerbalOrdersMenuBins: string = displayNoteOrderTypes?.VerbalOrdersMenuBins as string;
const verbalOrdersMenuBinsAry: string[] = VerbalOrdersMenuBins
  ? VerbalOrdersMenuBins.split(',')
  : [];
const generalOrderBins: string = displayNoteOrderTypes?.GeneralOrderBins as string;
const generalOrderBinsAry: string[] = generalOrderBins
  ? generalOrderBins.split(',')
  : [];
const locChangeBins: string = displayNoteOrderTypes?.LOCchangeBins as string;
const locChangeBinsAry: string[] = locChangeBins
  ? locChangeBins.split(',')
  : [];
const facChangeBins: string = displayNoteOrderTypes?.FACchangeBins as string;
const facChangeBinsAry: string[] = facChangeBins
  ? facChangeBins.split(',')
  : [];
const admitOrderBins: string = displayNoteOrderTypes?.AdmitOrderBins as string;
const admitOrderBinsAry: string[] = admitOrderBins
  ? admitOrderBins.split(',')
  : [];
const dischargeOrderBins: string = displayNoteOrderTypes?.DischargeOrderBins as string;
const dischargeOrderBinsAry: string[] = dischargeOrderBins
  ? dischargeOrderBins.split(',')
  : [];
const psoOrderBins: string = displayNoteOrderTypes?.PSOorderBins as string;
const psoOrderBinsAry: string[] = psoOrderBins ? psoOrderBins.split(',') : [];
const medOrderBins: string = displayNoteOrderTypes?.MedOrderBins as string;
const medOrderBinsAry: string[] = medOrderBins ? medOrderBins.split(',') : [];
const cpfOrderWidgetBins: string[] = window.env?.cpfOrderWidgetBins
  ? window.env?.cpfOrderWidgetBins.split(',')
  : [];
const cpfOrderBins: string = displayNoteOrderTypes?.CPFOrderBins as string;
const cpfOrderBinsAry: string[] = cpfOrderBins ? cpfOrderBins.split(',') : [];
const actualCPFOrdersBinsArr: string[] = cpfOrderWidgetBins.filter((x) =>
  cpfOrderBinsAry.includes(x),
);
const prnOrderWidgetBins: string[] = window.env?.prnOrderWidgetBins
  ? window.env?.prnOrderWidgetBins.split(',')
  : [];
const prnOrderBins: string = displayNoteOrderTypes?.PRNOrderBins as string;
const prnOrderBinsAry: string[] = prnOrderBins ? prnOrderBins.split(',') : [];
const actualPRNOrdersBinsArr: string[] = prnOrderWidgetBins.filter((x) =>
  prnOrderBinsAry.includes(x),
);

// Generic function to see if the current agency id in the list of allowed bins
const checkBins = (allowedBins: string[], agency: string): boolean =>
  allowedBins.includes('*') || (!!agency && allowedBins.includes(agency));

// determine whether a menu item is allowed to be displayed.
export const isCascadedMenuItemAllowed = (
  cmi: CascadeMenuItem,
  agency: string,
  isIDGTagged: boolean,
  isEATagged = false,
): boolean => {
  switch (cmi.name) {
    case IDG_MENU:
      return !isIDGTagged;
    case EA_MENU:
      return !isEATagged;
    case VERBAL_ORDERS_MENU:
      return checkBins(verbalOrdersMenuBinsAry, agency);
    case GeneralOrder:
      return checkBins(generalOrderBinsAry, agency);
    case LOCchange:
      return checkBins(locChangeBinsAry, agency);
    case FACchange:
      return checkBins(facChangeBinsAry, agency);
    case AdmitOrder:
      return checkBins(admitOrderBinsAry, agency);
    case DischargeOrder:
      return checkBins(dischargeOrderBinsAry, agency);
    case PSOorder:
      return checkBins(psoOrderBinsAry, agency);
    case PRNOrder:
      return checkBins(actualPRNOrdersBinsArr, agency);
    case MedicationChange:
      return checkBins(medOrderBinsAry, agency);
    case CPVisitFrequencies:
      return checkBins(actualCPFOrdersBinsArr, agency);
  }

  return true;
};
